// extracted by mini-css-extract-plugin
export default {"modal":"ModalGoTo_modal__CT6ms col-12 col-m-8 col-l-6","buttons":"ModalGoTo_buttons__B19nJ","buttonCancel":"ModalGoTo_buttonCancel__fh7fm","title":"ModalGoTo_title__Bt+lM"};